/**
 * Bottom/side padding for OmmnioSign fixed action bars.
 *
 * Desktop / SignatureModal uses the 16px default. RN WebView sets
 * `--ommnio-sign-action-bar-padding-bottom` via `embeddedWebView.css` when
 * `html.ommniosign-embedded` is present (OMM-619). Embedded footers override
 * this via `.ommniosign-embedded-actions` in embeddedWebView.css.
 */
export const ommnioSignSafeAreaPadding = {
  paddingBottom: 'var(--ommnio-sign-action-bar-padding-bottom, 16px)',
  paddingLeft: 'max(16px, env(safe-area-inset-left, 0px))',
  paddingRight: 'max(16px, env(safe-area-inset-right, 0px))',
};
